import { useEffect, useState } from "react";
import { applyTeamTheme, clearTeamTheme } from "./teamTheme";

const useTeamTheme = (teamInput) => {
  const [useTeamColors, setUseTeamColors] = useState(() => {
    return localStorage.getItem("useTeamColors") !== "false";
  });

  useEffect(() => {
    // Listen for team colors setting changes from Settings component
    const handleTeamColorsChange = (event) => {
      setUseTeamColors(event.detail.useTeamColors);
    };

    window.addEventListener("teamColorsSettingChanged", handleTeamColorsChange);
    return () => window.removeEventListener("teamColorsSettingChanged", handleTeamColorsChange);
  }, []);

  useEffect(() => {
    if (useTeamColors && teamInput) {
      applyTeamTheme(teamInput);
    } else {
      clearTeamTheme();
    }

    return () => {
      clearTeamTheme();
    };
  }, [teamInput, useTeamColors]);
};

export default useTeamTheme;
